import { Outlet } from "react-router-dom";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRole from "../../authorization/hooks/useHasRole";

import SuperAdminFinanceView from "../views/SuperAdminFinanceView/SuperAdminFinanceView";

export default function SuperAdminFinance() {
	const hasRole = useHasRole();

	if (!hasRole("owner", "admin")) {
		return <Unauthorized />;
	}

	return (
		<SuperAdminFinanceView>
			<Outlet />
		</SuperAdminFinanceView>
	);
}
